import { render, staticRenderFns } from "./BoundPropertyQuotatorNonProportional.vue?vue&type=template&id=5c08e1aa&"
import script from "./BoundPropertyQuotatorNonProportional.vue?vue&type=script&lang=js&"
export * from "./BoundPropertyQuotatorNonProportional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports